// assets/wholesale-moq.js
(() => {
  if (typeof window.IS_WHOLESALE !== 'undefined' && !window.IS_WHOLESALE) return;

const EXEMPT_MATCH = /\b(decaf|matcha)\b/i;

const RULES = [
  { match: /\b1(\.0+)?\s*kg\b|\b1000\s*g\b/i, step: 12, min: 12 },
  { match: /\b250\s*g\b|\b0\.25\s*kg\b/i, step: 25, min: 25 }
];

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function parseIntSafe(v) {
    const n = parseInt(String(v ?? '').replace(/[^\d]/g, ''), 10);
    return Number.isFinite(n) ? n : NaN;
  }

  function coerceQty(qty, rule) {
    const n = parseIntSafe(qty);
    if (!rule) return n;
    if (!Number.isFinite(n) || n < rule.min) return rule.min;
    const rem = n % rule.step;
    return rem === 0 ? n : n + (rule.step - rem);
  }

  function findProductRoot(el) {
    return el?.closest?.('.product, .product__info-wrapper, main, .shopify-section') || document;
  }

  function getContextText(root) {
    const parts = [];

    const h1 = $('h1', root) || $('h1', document);
    if (h1?.textContent) parts.push(h1.textContent.trim());

    const fieldsets = $$('fieldset', root);
    for (const fs of fieldsets) {
      const legend = (fs.querySelector('legend')?.textContent || '').trim().toLowerCase();
      const label = (fs.querySelector('.form__label')?.textContent || '').trim().toLowerCase();

      if (legend === 'weight' || label === 'weight') {
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) {
          const l = checked.id ? fs.querySelector(`label[for="${checked.id}"]`) : null;
          parts.push((l?.textContent || checked.value || '').trim());
        } else {
          const sel = fs.querySelector('select');
          if (sel) {
            const opt = sel.options?.[sel.selectedIndex];
            parts.push((opt?.text || sel.value || '').trim());
          }
        }
      }
    }

    return parts.filter(Boolean).join(' ').trim();
  }

  function isExempt(root) {
    return EXEMPT_MATCH.test(getContextText(root));
  }

  function getRule(root) {
    const text = getContextText(root);
    return RULES.find(r => r.match.test(text)) || null;
  }

  function ensureMsg(root) {
    let el = root.querySelector('[data-wholesale-qty-message]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-wholesale-qty-message', 'true');
      el.style.marginTop = '0.75rem';
      el.style.fontSize = '0.95rem';
      el.style.lineHeight = '1.3';
      el.style.color = '#b00020';
      const form = root.querySelector('form[action*="/cart/add"]') || root;
      form.appendChild(el);
    }
    return el;
  }

  function applyQty(root, rule, announce = false) {
    const qtyInput = root.querySelector('input[name="quantity"]') || $('input[name="quantity"]');
    if (!qtyInput) return;

    if (!rule) {
      qtyInput.min = '1';
      qtyInput.step = '1';
      const msg = root.querySelector('[data-wholesale-qty-message]');
      if (msg) msg.textContent = '';
      return;
    }

    qtyInput.min = String(rule.min);
    qtyInput.step = String(rule.step);

    const corrected = coerceQty(qtyInput.value, rule);
    qtyInput.value = String(corrected);

    const msg = ensureMsg(root);
    msg.textContent = announce
      ? `Wholesale ordering: quantities must be ${rule.min}+ in multiples of ${rule.step}. Quantity updated to ${corrected}.`
      : '';
  }

  function enforce(root, announce = false) {
    if (isExempt(root)) {
      applyQty(root, null, false);
      return;
    }
    const rule = getRule(root);
    if (!rule) return;
    applyQty(root, rule, announce);
  }

  function boot() {
    enforce(findProductRoot(document.body), false);

    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!t) return;
      const root = findProductRoot(t);

      if (
        t.matches?.('input[type="radio"][name^="options"]') ||
        t.matches?.('select[name^="options"]') ||
        t.closest?.('variant-selects') ||
        t.closest?.('fieldset') ||
        t.matches?.('input[name="quantity"]')
      ) {
        enforce(root, t.matches?.('input[name="quantity"]'));
      }
    });

    document.addEventListener('click', (e) => {
      const btn = e.target?.closest?.('button[name="plus"], button[name="minus"]');
      if (!btn) return;

      const root = findProductRoot(btn);
      if (isExempt(root)) return;

      const rule = getRule(root);
      const qtyInput = root.querySelector('input[name="quantity"]') || $('input[name="quantity"]');
      if (!rule || !qtyInput) return;

      e.preventDefault();
      const current = parseIntSafe(qtyInput.value);
      const base = Number.isFinite(current) ? current : rule.min;
      qtyInput.value = String(
        btn.name === 'plus' ? base + rule.step : Math.max(rule.min, base - rule.step)
      );
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }, true);

    document.addEventListener('click', (e) => {
      const addBtn = e.target?.closest?.('button[name="add"]');
      if (!addBtn) return;
      enforce(findProductRoot(addBtn), false);
    }, true);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();